import { NODES_EXTRA_DATA } from '../../const';
import { Block, NodeEnum } from '../../types';

export const BLOCKS: Block[] = Object.entries(NODES_EXTRA_DATA).map(
  ([type, nodeDefault]) => ({
    type: type as NodeEnum,
    title: nodeDefault.name,
    description: nodeDefault.description || nodeDefault.about,
  }),
);
